let excludeDays;
let cutOffHour;
let cutOffMinute;
let showLogic;

const dispatchFallback = 'Order today and your order will be mailed soon.';

let californiaTime = function () {
  d = new Date();
  utc = d.getTime() + (d.getTimezoneOffset() * 60000);
  nd = new Date(utc + (3600000 * (Date.today().isDaylightSavingTime() ? -4 : -5)));
  //  nd = nd.addHours(8.5);
  //  nd = nd.addDays(0);
  return nd;
}

let checkExcludeDays = function (date) {
  let newDate = date.toString('MM') + '/' + date.toString('dd') + '/' + date.toString('yyyy');
  if (excludeDays.includes(newDate)) {
    return true;
  } else {
    return false;
  }
}

function getDayName(dateStr, locale) {
  let date = new Date(dateStr);
  return date.toLocaleDateString(locale, { weekday: 'long' });
}

function showInline(selector) {
  document.querySelectorAll(selector).forEach(element => {
    element.classList.remove('hidden');
    element.style.display = 'inline';
  });
}

function hideElement(selector) {
  document.querySelectorAll(selector).forEach(element => {
    element.classList.add('hidden');
    element.style.display = 'none';
  });
}

function syncDispatchAccessibleText() {
  document.querySelectorAll('.next_day_dispatch').forEach(container => {
    const a11yMessage = container.querySelector('[data-shipping-dispatch-a11y]');

    if (!a11yMessage) return;

    const fallback = container.getAttribute('data-shipping-dispatch-fallback') || dispatchFallback;
    const within = getVisibleText(container, '.shipping_logic_within');
    const dispatchDay = getText(container, '.shipping_logic_dispatch') || 'soon';
    const midText = getVisibleText(container, '.shipping_mid_text');
    const afterText = getVisibleText(container, '.shipping_after_text');
    const originText = container.getAttribute('data-shipping-dispatch-origin')?.trim();
    const orderText = within || getVisibleText(container, '.shipping_logic_today') || 'today';
    const sentence = container.querySelector('.shipping_logic_dispatch')
      ? [
          `Order ${orderText}`,
          midText,
          `and your order will be mailed ${dispatchDay}`,
          afterText,
          originText ? `${originText}.` : ''
        ]
          .filter(Boolean)
          .join(' ')
          .replace(/\s+/g, ' ')
          .replace(/\s+\./g, '.')
          .trim()
      : fallback;

    const finalSentence = isCompleteDispatchSentence(sentence) ? sentence : fallback;

    a11yMessage.textContent = finalSentence;
  });
}

function getText(container, selector) {
  return container.querySelector(selector)?.textContent.replace(/\s+/g, ' ').trim();
}

function getVisibleText(container, selector) {
  const element = container.querySelector(selector);

  if (!element || element.classList.contains('hidden') || element.style.display === 'none') return '';

  return element.textContent.replace(/\s+/g, ' ').trim();
}

function isCompleteDispatchSentence(sentence) {
  return Boolean(
    sentence &&
      !sentence.includes('within the next and') &&
      !sentence.includes('within the next your') &&
      !sentence.includes('mailed .') &&
      /Order .+ and your order will be mailed .+/i.test(sentence)
  );
}

let getNextDispatchDay = function () {
  let nextAvailableDate;
  let hasExclude = false;
  for (let i = 0; i <= 9999; i++) {
    let currentDay = californiaTime().add(i).day();
    if (checkExcludeDays(currentDay) || currentDay.getDay() == 0) {
      hasExclude = true;
      continue;
    } else {
      if (i == 0) {
        if (californiaTime().getHours() < cutOffHour) {
          nextAvailableDate = currentDay;
          break;
        } else {
          nextAvailableDate = currentDay;
          continue;
        }
      } else {
        if (hasExclude) {
          nextAvailableDate = currentDay;
        } else {
          if (californiaTime().getHours() < cutOffHour) {
            nextAvailableDate = currentDay.add(-1).day();
          } else {
            nextAvailableDate = currentDay;
          }
        }
        break;
      }
    }
  }
  return nextAvailableDate;
}

let showCutoff = function () {
  let dateToday = new Date(californiaTime().toString('yyyy') + '/' + californiaTime().toString('MM') + '/' + californiaTime().toString('dd'));
  let dateDispatch = new Date(getNextDispatchDay().toString('yyyy') + '/' + getNextDispatchDay().toString('MM') + '/' + getNextDispatchDay().toString('dd'));
  let diffTime = Math.abs(dateDispatch - dateToday);
  let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  if (diffDays > 1) {
    // If more than a day away
    if (californiaTime().getHours() >= cutOffHour) {
      document.querySelectorAll('.shipping_logic_dispatch').forEach(element => {
        element.innerHTML = getDayName(getNextDispatchDay(), 'en-GB');
      });
      showInline('.shipping_logic_today');
      hideElement('.shipping_logic_within');
      return false;
    } else {
      return true;
    }
  } else if (diffDays == 1) {
    // If a day away
    if (californiaTime().getHours() >= cutOffHour) {
      return true;
    } else {
      document.querySelectorAll('.shipping_logic_dispatch').forEach(element => {
        element.innerHTML = 'tomorrow';
      });
      showInline('.shipping_logic_today');
      hideElement('.shipping_logic_within');
      return false;
    }
  } else {
    // Else show the current dispatch date
    return true;
  }
}

function initShippingHours() {
  const dispatchMessage = document.querySelector('.next_day_dispatch');

  if (!dispatchMessage) return;

  excludeDays = dispatchMessage.getAttribute('data-exclude-days').split(',');

  // Always hide "today" messaging initially
  hideElement('.shipping_logic_today');

  let cutOffTime = dispatchMessage.getAttribute('data-cutoff-time');
  if (cutOffTime) {
    cutOffTime = cutOffTime.split(":");
    cutOffHour = parseInt(cutOffTime[0]);
    cutOffMinute = parseInt(cutOffTime[1]);
  } else {
    cutOffHour = 12;
    cutOffMinute = 00;
  }

  // Mid text logic
  let midCutoffDate = new Date(dispatchMessage.getAttribute('data-mid-cutoff-date'));

  if (document.querySelector('.shipping_mid_text').innerHTML != '' && Date.compare(midCutoffDate.at({ hour: cutOffHour, minute: cutOffMinute }), californiaTime()) > 0) {
    document.querySelector('.shipping_mid_text').classList.remove('hidden');
    
    const newString = '<span> and</span>';
    document.querySelector('.shipping_mid_text').insertAdjacentHTML('afterend', newString);
  }

  // After text logic
  let afterCutoffDate = new Date(dispatchMessage.getAttribute('data-after-cutoff-date'));

  if (dispatchMessage.getAttribute('data-after-cutoff-date') != '' && Date.compare(afterCutoffDate.at({ hour: cutOffHour, minute: cutOffMinute }), californiaTime()) > 0) {
    document.querySelector('.shipping_after_text').classList.remove('hidden');
  }

  if (californiaTime().is().mon() || californiaTime().is().tue() || californiaTime().is().wed() || californiaTime().is().thu() || californiaTime().is().fri()) {
    if (Date.compare(californiaTime(), californiaTime().at({ hour: cutOffHour, minute: cutOffMinute })) < 0) {
      // If Monday - Friday (Pre Cutoff)
      // console.log('Monday - Friday (Pre Cutoff)');
      if (showCutoff()) {
        document.querySelectorAll('.shipping_logic_dispatch').forEach(element => {
          element.innerHTML = 'today';
        });
        let date1 = californiaTime().at({ hour: cutOffHour, minute: cutOffMinute }),
          date2 = californiaTime(),
          res = Math.abs(date1 - date2) / 1000,
          hours = Math.floor(res / 3600) % 24,
          minutes = Math.floor(res / 60) % 60;
        if (hours == 0) {
          document.querySelectorAll('.shipping_logic_hours').forEach(element => {
            element.innerHTML = (minutes + ' minutes');
          });
          showInline('.shipping_logic_within');
          document.querySelectorAll('.hours').forEach(element => {
            element.classList.add('hide');
          });
        } else {
          document.querySelectorAll('.shipping_logic_hours').forEach(element => {
            let currentTime = californiaTime();
            let cutoffTime = new Date(currentTime);
            cutoffTime.setHours(cutOffHour, cutOffMinute, 0, 0);
            element.innerHTML = (cutoffTime.getHours() - currentTime.getHours());
          });
          showInline('.shipping_logic_within');
        }

      }
    } else {
      // If Monday - Friday (Post Cutoff)
      // console.log('Monday - Friday (Post Cutoff)');
      if (showCutoff()) {
        if (californiaTime().is().fri()) {
          document.querySelectorAll('.shipping_logic_dispatch').forEach(element => {
            element.innerHTML = 'Monday';
          });
          showInline('.shipping_logic_today');
          hideElement('.shipping_logic_within');
        } else {
          document.querySelectorAll('.shipping_logic_dispatch').forEach(element => {
            element.innerHTML = 'tomorrow';
          });
          showInline('.shipping_logic_today');
          hideElement('.shipping_logic_within');
        }
      }
    }
  } else {
    if (californiaTime().is().sat()) {
      // If Saturday
      // console.log('Saturday');
      if (showCutoff()) {
        document.querySelectorAll('.shipping_logic_dispatch').forEach(element => {
          element.innerHTML = 'Monday';
        });
        showInline('.shipping_logic_today');
        hideElement('.shipping_logic_within');
      }
    } else {
      // If Sunday
      // console.log('Sunday');
      if (showCutoff()) {
        document.querySelectorAll('.shipping_logic_dispatch').forEach(element => {
          element.innerHTML = 'tomorrow';
        });
        showInline('.shipping_logic_today');
        hideElement('.shipping_logic_within');
      }
    }
  }
  const shippingHours = document.querySelector('.shipping_logic_hours');

  if (shippingHours && shippingHours.innerHTML.trim() && !shippingHours.innerHTML.includes('minutes')) {
    if (parseInt(shippingHours.innerHTML) == 1) {
      document.querySelector('.next_day_dispatch .hours').innerHTML = ('hour');
    } else {
      document.querySelector('.next_day_dispatch .hours').innerHTML = ('hours');
    }
  } else if (shippingHours && !shippingHours.innerHTML.trim()) {
    hideElement('.shipping_logic_within');
  } else {
    document.querySelector('.next_day_dispatch .hours').innerHTML = '';
  }

  syncDispatchAccessibleText();

  setTimeout(function () {
    document.querySelector('.next_day_dispatch').style.opacity = 1;
  }, 500);
}

document.addEventListener('DOMContentLoaded', e => {
  initShippingHours();
});
